/**
 * Product helper
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

export default class Product {

  constructor () {

    App.dispatcher.listen('breakpoint.xs', () => {
      this.hideAll();
    });

    App.dispatcher.listen('breakpoint.sm', () => {
      this.showAll();
    });

  }

  showDescription () {
    let el = document.getElementById('collapse-description')
    el && el.classList.add("show")
  }

  hideDescription () {
    let el = document.getElementById('collapse-description')
    el && el.classList.remove("show")
  }

  showSpecs () {
    let el = document.getElementById('collapse-specs')
    el && el.classList.add("show")
  }

  hideSpecs () {
    let el = document.getElementById('collapse-specs')
    el && el.classList.remove("show")
  }

  showAll () {
    this.showDescription();
    this.showSpecs();
  }

  hideAll () {
    this.hideDescription();
    this.hideSpecs();
  }

}
